import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  boxShadow,
  breakpoints,
  colors,
  gutter,
  verticalGutter
} from '../styles';

/**
 * grey boxed container for page header area
 */
const StyledPageHeader = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: ${verticalGutter}rem 0${({ overlap }) =>
  overlap && ` ${verticalGutter}rem`};
  margin-bottom: ${({ overlap }) =>
    overlap ? null : ` ${verticalGutter * 2}rem`};

  @media screen and (min-width: ${breakpoints.computer}) {
    flex-direction: row;
    .ui.header {
      margin: 0;
    }
  }

  &:before {
    content: '';
    position: absolute;
    left: ${gutter / -2}px;
    top: ${verticalGutter * -1}rem;
    width: calc(100% + ${gutter}px);
    height: calc(100% + ${verticalGutter * 2}rem);
    background-image: linear-gradient(
      ${colors.lighterGrey},
      ${colors.greyBackground}
    );
    box-shadow: ${boxShadow.medium};
    z-index: -1;

    @media screen and (min-width: ${breakpoints.tablet}) {
      left: ${gutter * -1}px;
      width: calc(100% + ${gutter * 2}px);
      /* no reason, just from design */
      height: ${({ overlap }) =>
        overlap ? `calc(100% + ${verticalGutter * 3.75}rem` : null});
    }
    @media screen and (min-width: ${breakpoints.widescreenMonitor}) {
      left: ${gutter * -1.2}px;
      width: calc(100% + ${gutter * 2.4}px);
    }
  }
`;

const PageHeader = ({ children, overlap, ...rest }) => (
  <StyledPageHeader overlap={overlap} {...rest}>
    {children}
  </StyledPageHeader>
);

PageHeader.propTypes = {
  children: PropTypes.node,
  overlap: PropTypes.bool
};
export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js